import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useTermActions() {
  const [isLoading, setLoading] = useState(false);

  const remove = useCallback((termId) => {
    setLoading(true);
    return quarkusApi.delete(`/terms/${termId}`, authHeader()).finally(() => setLoading(false));
  }, []);

  const fetchUrl = useCallback((termId) => {
    setLoading(true);
    return quarkusApi.get(`/terms/${termId}/url`, authHeader()).finally(() => setLoading(false));
  }, []);

  return { remove, fetchUrl, isLoading };
}
